export { RelatedPosts, type RelatedPostsProps } from "./RelatedPosts";
